<template>
  <div>
    <Nav
      ref="nav"
      :showMobileSearch="false"
      @changeKey="changeKey"
      @changeAdvance="changeAdvance"
    />
    <!-- 检索结果 -->
    <div class="fav-main">
      <div class="main-box">
        <div class="home-tit sch">
          <div class="t-l">
            <span class="name"> <i class="search"></i>检索结果</span>
          </div>
        </div>
        <div class="fav-tap">
          <div class="tap">
            <b
              @click="tapClick('searchRecord')"
              :class="tapItemName === 'searchRecord' ? 'cur' : ''"
              ><i class="record"></i>唱片</b
            >
            <a-divider type="vertical" />
            <b
              @click="tapClick('searchSong')"
              :class="tapItemName === 'searchSong' ? 'cur' : ''"
              ><i class="song"></i>曲目</b
            >
            <a-divider type="vertical" />
            <b
              @click="tapClick('searchMusician')"
              :class="tapItemName === 'searchMusician' ? 'cur' : ''"
              ><i class="musician"></i>乐人</b
            >
            <a-divider type="vertical" />
            <b
              @click="tapClick('searchCompany')"
              :class="tapItemName === 'searchCompany' ? 'cur' : ''"
              ><i class="com"></i>机构团体</b
            >
          </div>
        </div>
        <div>
          <record ref="searchRecord" v-if="tapItemName == 'searchRecord'" />
          <song ref="searchSong" v-if="tapItemName == 'searchSong'" />
          <musician
            ref="searchMusician"
            v-if="tapItemName == 'searchMusician'"
          />
          <company ref="searchCompany" v-if="tapItemName == 'searchCompany'" />
        </div>
      </div>
    </div>
    <a-modal title="播放，仅剩一步"
             :visible="playLoginvisible"
             :footer="null"
             @cancel="handleCancel">
      <p>您还未登录，暂无播放权限。 点击登录后即可畅听 ：)</p>
      <div class="modal-btn">
        <a href="javascript:" class="cancel" @click="handleCancel">取消</a>
        <a :href="loginHref" class="confirm">去登录</a>
      </div>
    </a-modal>


    <a-modal title="收藏，仅剩一步"
             :visible="sc"
             @ok="handleOk"
             :footer="null"
             @cancel="schandleCancel">
      <p>您还未登录，暂无收藏权限。 点击登录后即可收藏 ：)</p>
      <div class="modal-btn">
        <a href="javascript:" class="cancel" @click="schandleCancel">取消</a>
        <a :href="loginHref" class="confirm" @click="handleOk">去登录</a>
      </div>
    </a-modal>


    <a-modal title="该曲目暂无法播放"
             :visible="noqmplay"
             :footer="null"
             @cancel="noqmhandleCancel">
      <p>该曲目暂无法播放，您可以逛逛其他内容</p>
      <div class="modal-btn">
        <a  href="javascript:" class="confirm" @click="noqmhandleCancel">知道了</a>
      </div>
    </a-modal>


    <a-modal title="该唱片暂无法播放"
             :visible="nocpplay"
             :footer="null"
             @cancel="nocphandleCancel">
      <p>该曲目暂无法播放，您可以逛逛其他内容</p>
      <div class="modal-btn">
        <a  href="javascript:" class="confirm" @click="nocphandleCancel">知道了</a>
      </div>
    </a-modal>
    <Footer />
  </div>
</template>

<script>
import record from "./record.vue";
import song from "./song.vue";
import musician from "./musician.vue";
import company from "./company.vue";

import Nav from "@/components/nav";
import Footer from "@/components/footer";
import Player from "@/components/player";
import { eventBus } from "./../../util/eventBus";
import { getRecord } from "@/api/index";
export default {
  components: {
    Nav,
    Footer,
    Player,
    record,
    song,
    musician,
    company,
  },
  data() {
    return {
      loginHref: null,
      // isLogin:true,
      playLoginvisible:false,
      sc:false,
      noqmplay:false,
      nocpplay:false,
      keyword: this.$route.query.keyword || "",
      tapName: "searchRecord",
      tapItemName: "searchRecord",
      routeName: this.$route.name,
    };
  },
  mounted() {
    this.loginHref = this.GLOBAL.BASE_LOGIN_URL + window.location.href;
    // this.$refs[this.tapName].query();
     this.onSearch();
  },
  created() {
    this.showAdvance = false;
  },
  methods: {
    changeKey(a) {
      
      this.keyword = a;
      if (this.$route.query.keyword !== a) {
        this.$router.push(
          this.$route.path + "?keyword=" + a
        );
      } else {
        this.$refs[this.tapName].initFilterKeys();
        // this.$refs[this.tapName].query();
      }
      this.showAdvance = false;
    },
    //点击切换搜索模块
    tapClick(item){
      this.tapItemName = item;
      this.tapName = item;
      setTimeout(() => {
            this.$refs[this.tapName].query();
      }, 100);
    },
    //点击导航的高级搜索
    changeAdvance() {
      this.showAdvance = true;
    },
    //检测检索
    //点击高级搜索的时候，需要清空普通搜索的内容
    onSearch() {
      var that = this;
      eventBus.$on("advanceSearch", (res, item) => {
        that.$refs.nav.hasAdvance = res && res.length > 0;
        that.$refs.nav.keyword = null;
        that.$nextTick(() => {
          that.showAdvance = false;
          that.tapItemName = item;
          that.tapName = item;
          setTimeout(() => {
            that.$refs[that.tapName].cdtn = res;
            that.$refs[that.tapName].currentPage = 1;
            that.$refs[that.tapName].query();
          }, 100);
        });
      });
    },
    // 重置
    onReset() {
      let inputArr = this.searchColumns[this.tapName];
      for (let i = 0, len = inputArr.length; i < len; i++) {
        this.searchColumns[this.tapName][i].value = "";
      }
    },
    coll(isFav){
      this.$message.open({
        content: isFav ? "已收藏" : "已取消收藏",
        icon: (
          <img
            style="width:14px;height:14px;margin-right:5px"
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEUSURBVHgBpZFNbsIwEIVnvEBZplL/dqUnqHqD3qDpBsyuPUF7g6Q3oCeougOvygm4AtwgOyQiBFsEzDC2CAo/gZA8yYn9xv409kPIaBoE/sLzAiR6UIgzGb2rTie2tZHW9RrzKzH7BDCsKTVIa1aYTsat1pciChnAh121ZROK/5k1xYuXzD/3xrS3oLHW78j8CyUkHb7dGfOv7EIxh1BSAnANYKL1CzD3oYLmRM9K7l6HivIQnxSsVgOoKGaO3WMnzeYUDtMqBpH0brvdR/fYktgHlJQEFbm//Vzb+DbGZe1wJGf/XDNZf9JohIQYFYXcGPOdLnG/Xgi2BzkKOgs7AskF5cJyICdBB7ATkEKysETGuX1rfziAH44aflAAAAAASUVORK5CYII="
          />
        ),
      });
    },
    handleCancel(){
      this.playLoginvisible = false
    },
    schandleCancel(){
      this.sc = false;
    },
    noqmhandleCancel(){
      this.noqmplay = false
    },
    nocphandleCancel(){
      this.nocpplay = false;
    },
    handleOk(){

    },
    showTk(t){
        //console.log(13);
      //未登录播放
      if(t == 1){
        this.playLoginvisible = true;
      }
      //未登录收藏
      if(t == 2){
        this.sc = true;
      }
      //无唱片播放
      if(t == 3){
        this.nocpplay = true;
      }
      //无曲目播放
      if(t == 4){
        this.noqmplay = true;
      }
    }
  },
};
</script>
